/**
 * This file contains all Proxima Nova font styles to use throughout the code base.
 *
 * When adding to or modifying this file, keep in sync with less/fonts/proxima.less and
 * ProximaFont.stories.tsx.
 * Additionally check the ProximaFont story in storybook to ensure that scrollbars are not rendered
 * on divs with the new or updated font.
 *
 * Note that there are legacy versions of each font. These have line heights that are not large enough to
 * account for their font size, leading to situations where the font can take up more vertical space than
 * its enclosing div. If y-overflow is handled with scrollbars, this leads to scrollbars being undesirably
 * rendered on simple text blocks. Therefore, use the non-legacy versions for new applications.
 *
 * TODO(BNCH-24056): Convert existing legacy proxima nova fonts to their non-legacy versions.
 */

const FONT_LINE_HEIGHT_PROXIMA: 1.5 = 1.5;
export const FONT_WEIGHT_PROXIMA_SEMIBOLD: 600 = 600;
export const FONT_WEIGHT_PROXIMA_REGULAR: 400 = 400;
export const FONT_FAMILY_PROXIMA = 'Proxima Nova, Helvetica, Arial, sans-serif';
export const FONT_FAMILY_MONOSPACED = 'Inconsolata, Courier New';

export const BASE_FONT_PROXIMA = {
  lineHeight: FONT_LINE_HEIGHT_PROXIMA,
};

export const FONT_PROXIMA_19 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 19,
};
export const FONT_PROXIMA_18 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 18,
};
export const FONT_PROXIMA_17 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 17,
};
export const FONT_PROXIMA_16 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 16,
};
export const FONT_PROXIMA_15 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 15,
};
export const FONT_PROXIMA_14 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 14,
};
export const FONT_PROXIMA_13 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 13,
};
export const FONT_PROXIMA_12 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 12,
};
export const FONT_PROXIMA_11 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 11,
};
export const FONT_PROXIMA_10 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 10,
};
export const FONT_PROXIMA_9 = {
  ...BASE_FONT_PROXIMA,
  fontSize: 9,
};
export const FONT_PROXIMA_TITLE = {
  ...FONT_PROXIMA_13,
  fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
};

export const LEGACY_FONT_PROXIMA_19 = {
  fontSize: 19,
  lineHeight: '28px',
};
export const LEGACY_FONT_PROXIMA_18 = {
  fontSize: 18,
  lineHeight: '24px',
};
export const LEGACY_FONT_PROXIMA_17 = {
  fontSize: 17,
  lineHeight: '24px',
};
export const LEGACY_FONT_PROXIMA_15 = {
  fontSize: 15,
  lineHeight: '24px',
};
export const LEGACY_FONT_PROXIMA_14 = {
  fontSize: 14,
  lineHeight: '20px',
};
export const LEGACY_FONT_PROXIMA_13 = {
  fontSize: 13,
  lineHeight: '16px',
};
export const LEGACY_FONT_PROXIMA_12 = {
  fontSize: 12,
  lineHeight: '16px',
};
export const LEGACY_FONT_PROXIMA_TITLE = {
  ...LEGACY_FONT_PROXIMA_13,
  fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
};
